// pictureData.js
export const pictureData = [
  {
    title: 'Sticky wall ball',
    path: "https://lh3.googleusercontent.com/d/1uWVkU_iCHaqS9ymfWCgZ7RErKoJIfroF=s1000?authuser=0",
  },
  {
    title: 'Pipe cleaner',
    path: "https://lh3.googleusercontent.com/d/1Ti0DS9owEqr8prE0wrbocLKR_hFSLLvj=s1000?authuser=0",
  },
  {
    title: 'Transffering activity',
    path: "https://lh3.googleusercontent.com/d/1yeV22kI1iarVrIw02Xh8yX_0_9xlYRGU=s1000?authuser=0",
  },
  {
    title: 'Peeka boo',
    path: "https://lh3.googleusercontent.com/d/1dciazxwMRE6jT5JYFldCAILAsu5_vA9P=s1000?authuser=0",
  },
  {
    title: 'Color Matching',
    path: "https://lh3.googleusercontent.com/d/1WFqFjY77tm3WFu_ZrXnjL0oz8-Bt9H7g=s1000?authuser=0",
  },
  {
    title: 'Fishing game',
    path: "https://lh3.googleusercontent.com/d/1KLPCfM3k1SYc7jgPjt7TvGKMsIhoir3F=s1000?authuser=0",
  },
  {
    title: 'Block building',
    path: "https://lh3.googleusercontent.com/d/1IGEiPZBOKLqdA_DUDbpMivfbOL6aWRxW=s1000?authuser=0"
  },
  {
    title: "title",
    path: "https://lh3.googleusercontent.com/d/1Ti0DS9owEqr8prE0wrbocLKR_hFSLLvj=s1000?authuser=0"

  },
  {
    title: "title",
    path: "https://lh3.googleusercontent.com/d/1Ti0DS9owEqr8prE0wrbocLKR_hFSLLvj=s1000?authuser=0",

  },
  {
    title: 'Sorting shapes',
    path: "https://lh3.googleusercontent.com/d/1Ti0DS9owEqr8prE0wrbocLKR_hFSLLvj=s1000?authuser=0",
  },
  {
    title: 'Two piceces Flash cards',
    path: "https://lh3.googleusercontent.com/d/18wWqQ04nJM_S_MTUB9E88cyevH_NtFEx=s1000?authuser=0",
  },
  {
    title: 'Block building',
    path: "https://lh3.googleusercontent.com/d/1Ti0DS9owEqr8prE0wrbocLKR_hFSLLvj=s1000?authuser=0"
  },
  {
    title: 'Cotton ball sheep',
    path: "https://lh3.googleusercontent.com/d/1Yum1QLsKCtE1bFqY1yQ6jNaIwqQlPO8F=s1000?authuser=0",
  },
  // {
  //   title: 'Multiple pieces Puzzle',
  //   path: "https://lh3.googleusercontent.com/d/1Ti0DS9owEqr8prE0wrbocLKR_hFSLLvj=s1000?authuser=0",
  // },
  {
    title: '2-pieces Puzzle',
    path: "https://lh3.googleusercontent.com/d/1Ti0DS9owEqr8prE0wrbocLKR_hFSLLvj=s1000?authuser=0",
  },
  {
    title: 'Threading pasta',
    path: "https://lh3.googleusercontent.com/d/192oSGDmWC33ASh-2mqXPFtC4FXMym_6Y=s1000?authuser=0",
  },
  {
    title: 'Sorting shapes',
    path: "https://lh3.googleusercontent.com/d/1xfPE_TnFyFyG6DmOu9oOU5keOUFmIYuZ=s1000?authuser=0",
  },
  {
    title: 'Smelling flower',
    path: "https://lh3.googleusercontent.com/d/1YZ_q07wiwupZaXby4p44zRmRoCe1pqQW=s1000?authuser=0",
  },
  {
    title: 'Fitting pipes',
    path: "https://lh3.googleusercontent.com/d/1V7jacSew1ewP67Jt1mBqCgCHY7sze4KD=s1000?authuser=0",
  },
  {
    title: 'Book reading',
    path: "https://lh3.googleusercontent.com/d/1y1R7ucgNNEbuC_Up3_hMPLNbcYWQwZHj=s1000?authuser=0"
  },
  // {
  //   title: 'Identifying Flash cards',
  //   path: "https://lh3.googleusercontent.com/d/1Ti0DS9owEqr8prE0wrbocLKR_hFSLLvj=s1000?authuser=0"
  // },
  {
    title: 'Grab animals',
    path: "https://lh3.googleusercontent.com/d/1SPh5_F5ZLzQBUsHlLiIm7kQdhohRSDGr=s1000?authuser=0",
  },
  {
    title: 'Peg activity',
    path: "https://lh3.googleusercontent.com/d/173fVq1O5E7r1ZyiU68UbU26tJDbCyDIX=s1000?authuser=0",
  },
];
